"use client";

import { formatImageUrl } from "@/lib/utils";
import { TProductMedia } from "@/types/comments";
import Image from "next/image";
import { useCallback, useEffect, useState } from "react";

const CommentMedia = ({ items }: { items: TProductMedia[] }) => {
	const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);

	const openModal = (index: number) => {
		setSelectedImageIndex(index);
	};

	const closeModal = useCallback(() => {
		setSelectedImageIndex(null);
	}, []);

	useEffect(() => {
		const handleEscKey = (event: KeyboardEvent) => {
			if (event.key === "Escape") {
				closeModal();
			}
		};

		if (selectedImageIndex !== null) {
			document.addEventListener("keydown", handleEscKey);
		}

		return () => {
			document.removeEventListener("keydown", handleEscKey);
		};
	}, [selectedImageIndex, closeModal]);

	if (items.length === 0) return null;

	return (
		<div className="w-full">
			{/* Image Grid */}
			<div className="flex gap-2">
				{items.slice(0, 4).map(
					(item, index) =>
						item.objectPath && (
							<div key={index} onClick={() => openModal(index)}>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<Image
									src={formatImageUrl(item.objectPath)}
									alt={item.alt || `Comment Media ${item.id}`}
									className="h-full w-auto object-contain"
									width={200}
									height={200}
								/>
							</div>
						)
				)}
			</div>
		</div>
	);
};

export default CommentMedia;
